import React from 'react'

import { Box } from '@mui/material'
import NumSearchesBlock from 'Pages/ReportsAlerts/Reports/@components/NumSearchesBlock'

export default function numSearchesColumn() {

	return {
		name: 'numSearches',
		label: 'Num Searches',
		options: {
			customBodyRowRenderLite: (value) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: value > 1000 ? 'colors.red' : 'colors.green'}}>
					<NumSearchesBlock numSearches={value}/>
				</Box>
			)
		}
	}
}
